import { IconBrandYoutube } from '@tabler/icons-react'

import { VideoDisplayBlock as RenderVideoDisplayBlock } from '../../templateRenderer/DisplayBlocks/VideoDisplayBlock'
import { VideoDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  InputField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<VideoDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'video' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'YouTube video',
    icon: IconBrandYoutube,
    helpText: 'Embed a video from YouTube',
    hideName: true,
    hideDescription: true,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'url',
      label: 'Video URL',
      field: InputField,
      helpText: 'The link to a YouTube video',
      required: true,
    },
    {
      name: 'caption',
      label: 'Caption',
      helpText: 'The text that will be displayed along side your video',
      field: InputField,
    },
  ]

  public override mapFormValueToBlock(
    block: VideoDisplayBlock
  ): VideoDisplayBlock {
    return block
  }

  public override renderBlock(block: VideoDisplayBlock): React.ReactNode {
    return <RenderVideoDisplayBlock block={block} />
  }
}

export const VideoDisplayBlockConfig = new Config()
